import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration - using the same project as the mobile app
const firebaseConfig = {
    apiKey: "AIzaSyAdpX0pG3I5W26GwzpljFF07eZJRshFslY",
    authDomain: "yonex-ai.firebaseapp.com",
    projectId: "yonex-ai",
    storageBucket: "yonex-ai.firebasestorage.app",
    messagingSenderId: "310588227348",
    appId: "1:310588227348:web:a1c9fc59e1e29b22000c01"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Collection References
export const COLLECTIONS = {
    USERS: 'users',
    PRODUCTS: 'products',
    USER_PRODUCTS: 'userProducts',
    TRANSACTIONS: 'transactions',
    RECHARGE_REQUESTS: 'rechargeRequests',
    WITHDRAWAL_REQUESTS: 'withdrawalRequests',
    BANK_DETAILS: 'bankDetails',
    GIFT_CODES: 'giftCodes',
    ANNOUNCEMENTS: 'announcements',
    PAYMENT_CHANNELS: 'paymentChannels',
};

// Transaction Types
export const TRANSACTION_TYPES = {
    RECHARGE: 'recharge',
    WITHDRAW: 'withdraw',
    PURCHASE: 'purchase',
    DAILY_INCOME: 'daily_income',
    REFERRAL_BONUS: 'referral_bonus',
    GIFT_CODE: 'gift_code',
};

// Status Codes
export const STATUS = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    COMPLETED: 'completed',
};

export default app;
